import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import { Link } from 'react-router-dom';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

/* IMPORT YOUR IMAGES */
import Banner1 from "../../../assets/images/rrc/sibol/Alternate_floral_pattern_purple_12k_300dpi.jpg";
import Banner2 from "../../../assets/images/rrc/sibol/marxxgenx-809.jpg";
import Banner3 from "../../../assets/images/rrc/sibol/posterbg2.png";

export default function Banner() {

  const slides = [
    {
      id: '1',
      image: Banner1,
      title: "Racket Riot Club",
      subtitle: "Welcome to the Club",
      desc: "Connecting players and building the ultimate badminton community."
    },
    {
      id: '2',
      image: Banner2,
      title: "Play. Compete. Win.",
      subtitle: "Weekly Games",
      desc: "Join our community matches and level up your game.",
      buttonName: "Join Chat",
      buttonLink: "https://m.me/ch/AbaR2G6VV-6wAFqa/"
    },
    {
      id: '3',
      image: Banner3,
      title: "Tournaments & Events",
      subtitle: "Riot Moments",
      desc: "SIBOL: Racket Riot Club 2nd Anniversary Tournament",
      buttonName: "Register",
      buttonLink: "https://queue.racketriotclub.com/tournament"
    }
  ];

  return (
    <section className="rrc-hero">

      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        autoplay={{ delay: 10000, disableOnInteraction: false }}
        loop
        pagination={{ clickable: true }}
        className="rrc-hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="rrc-hero-slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="rrc-overlay" />

              <div className="container">
                <div className="rrc-content">

                  <p className="rrc-subtitle">{slide.subtitle}</p>

                  <h1 className="rrc-title">
                    {slide.title}
                  </h1>

                  <p className="rrc-description">
                    {slide.desc}
                  </p>
                  {slide.id === '1' && (
                    <>
                      <hr />
                      <div className="site-footer__social" style={{ display: 'flex', gap: '1.5rem', marginLeft: 10 }}>
                        <Link to="https://www.facebook.com/profile.php?id=61568695844672" target="blank"><i className="icon-facebook"></i></Link>
                        <Link to="https://www.instagram.com/racketriotclub/" target="blank"><i className="icon-instagram"></i></Link>
                      </div>
                    </>
                  )}
                  {slide.buttonName && (
                    <>
                      <hr />
                      <button
                        className="rrc-btn"
                        onClick={() => window.open(slide.buttonLink, "_blank")}
                      >
                        {slide.buttonName}
                      </button>
                    </>
                  )}
                </div>
              </div>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </section>
  );
}